module.exports = __webpack_public_path__ + "media/images/sp/stores/common/instagram/photographer_sns_06-2b8349c1afbd8b4c82134f4d9f92b451.jpg";